export enum EnAgrupamentoProcessos {
    SemAgrupamento = 1, // Não aparece em lugar algum
    VariaveisIndentificacao = 2, // Exibe no perfil do idoso
    Individual = 3, // Exibe no menu do topo
    Todos = 4, // Exibe no topo e no perfil do idoso
}
